import {
  IGetProblemDetailsAPIResponse,
  IGetProblemsFromLibraryAPIResponse,
  TGetLibraryProblemsParams,
  TQueryParams,
} from "@/types/problems.types";
import { HTTP_METHODS } from "@/constants/HttpConstants";
import { sendRequestToInterviewWithCredential } from "@/utils/request.utils";

export const getProblemsFromLibraryAPI = (params: TGetLibraryProblemsParams) =>
  sendRequestToInterviewWithCredential<IGetProblemsFromLibraryAPIResponse>({
    method: HTTP_METHODS.GET,
    url: "/interviews/search/problem/",
    params,
    paramsSerializer: (queryParams) => {
      const changeQueryParams = queryParams as TQueryParams;
      return Object.entries(changeQueryParams)
        .reduce<string[]>((previousParams, queryParam) => {
          const [paramKey, paramValue] = queryParam;
          if (
            (!paramValue && paramValue !== 0) ||
            (typeof paramValue === "object" && !paramValue.length)
          )
            return previousParams;
          if (Array.isArray(paramValue) && paramValue.length) {
            const paramInString = paramValue
              .map((value) => [paramKey, value].join("="))
              .join("&");
            return previousParams.concat(paramInString);
          }
          return previousParams.concat(queryParam.join("="));
        }, [])
        .join("&");
    },
  });

export const getProblemDetailApi = (problemSlug: string) =>
  sendRequestToInterviewWithCredential<IGetProblemDetailsAPIResponse>({
    method: HTTP_METHODS.GET,
    url: `/interviews/problem/${problemSlug}/`,
  });
